// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../../../../../../node_modules/@glennsl/bs-json/src/Json.mjs";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as PnmIntDataSource$PorterinFeature from "../data-source/PnmIntDataSource.mjs";
import * as PnmIntRepoConfig$PorterinFeature from "./PnmIntRepoConfig.mjs";
import * as PnmIntRepoHelper$PorterinFeature from "../helper/PnmIntRepoHelper.mjs";
import * as Network$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/Network.mjs";
import * as ApiUtils$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ApiUtils.mjs";

function validateBoundaries(pickup, drop) {
  var requestUrl = PnmIntDataSource$PorterinFeature.getBoundaryValidatorUrl(undefined);
  var payload = Json.stringify(PnmIntRepoHelper$PorterinFeature.encodeBoundaryValidationData(pickup, drop));
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnmIntRepoConfig$PorterinFeature.GeoValidationResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.postRequestV2(requestUrl, payload, PnmIntDataSource$PorterinFeature.getHeaders(undefined), undefined, undefined));
}

function createOrderInterest(data) {
  var requestUrl = PnmIntDataSource$PorterinFeature.getOrderInterestUrl(undefined);
  var payload = Json.stringify(PnmIntRepoHelper$PorterinFeature.encodeCreateLeadData(data));
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnmIntRepoConfig$PorterinFeature.CreateLeadResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.postRequestV2(requestUrl, payload, PnmIntDataSource$PorterinFeature.getHeaders(undefined), undefined, undefined));
}

function submitShiftReqBasicDetails(data) {
  var requestUrl = PnmIntDataSource$PorterinFeature.getShiftReqBasicDetailsUrl(undefined);
  var payload = Json.stringify(PnmIntRepoHelper$PorterinFeature.encodeShiftReqBasicDetailsData(data));
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnmIntRepoConfig$PorterinFeature.ShiftReqBasicDetailsResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.postRequestV2(requestUrl, payload, PnmIntDataSource$PorterinFeature.getHeaders(undefined), undefined, undefined));
}

function submitShiftReqLocationDetails(sr_external_id, pickup, drop) {
  var requestUrl = PnmIntDataSource$PorterinFeature.getShiftReqLocationDetailsUrl(undefined);
  var payload = Json.stringify(PnmIntRepoHelper$PorterinFeature.encodeShiftReqLocationDetailsData(sr_external_id, pickup, drop));
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnmIntRepoConfig$PorterinFeature.ShiftReqLocationDetailsResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.postRequestV2(requestUrl, payload, PnmIntDataSource$PorterinFeature.getHeaders(undefined), undefined, undefined));
}

export {
  validateBoundaries ,
  createOrderInterest ,
  submitShiftReqBasicDetails ,
  submitShiftReqLocationDetails ,
}
/* PnmIntDataSource-PorterinFeature Not a pure module */
